import React, {memo, useState, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from '../../models/stores/actions';
import { isMath, isNormalZhEnCss} from '../../utils';
import  * as TYPES  from '../../models/types';

import styles from './styles.module.scss';

const Index = memo((props) => {

  const dispatch = useDispatch();
  const {basicDrawerEvent} = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  const [liHeight, setLiHeight] = useState(538);

  // 样式判断
  const normal = useMemo(() => {
    const idLang = isNormalZhEnCss(lang, 'English');

    if (recReSizeReducer > 1920) {
      setLiHeight(idLang ? 522 : 538);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if (recReSizeReducer > 1440 && recReSizeReducer <= 1920) {
      setLiHeight(idLang ? 421 : 438);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if (recReSizeReducer > 1024 && recReSizeReducer <= 1440) {
      setLiHeight(idLang ? 376 : 376);
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if (recReSizeReducer > 750 && recReSizeReducer <= 1024) {
      setLiHeight(idLang ? 376 : 376);
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if (recReSizeReducer <= 750) {
      setLiHeight(idLang ? 278*2 : 278*2);
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  }, [recReSizeReducer, lang, liHeight]);

  // 判断是：桌面/移动端
  const isDesktopMobile = () => {
    const {data: {title, list}, type} = props.config;

    const marginTopCss = recReSizeReducer <= 750 ? null : {marginTop: '3px'};

    return (<>
      <h2 className="title text-center" ref={props.config.getRefs.innerTextRef} style={props.config.getRefs.innerTextStyles}><span>{title}</span></h2>
      <div className="list">
        <ul className="ulGrid" ref={props.config.getRefs.innerCardRef} style={props.config.getRefs.innerCardStyles}>
          {list.map((item, index) => {
            const desc = item.content[0].desc;
            return (
                <li
                    key={item.id}
                    onClick={() => handleClickShow(type, index)}
                    style={{
                      overflow: 'hidden',
                      height: isMath(recReSizeReducer, liHeight),
                    }}
                    
                >
                  <div className="innerBox">
                    <div 
                      className="pic"
                      style={{transition: 'all 1s'}}
                    >
                      <img src={item.img} alt=""/>
                    </div>
                    <div className="info">
                      <div className="left">
                        <div className="icon"><img src={item.icon} alt=""/>
                        </div>
                      </div>
                      <div className="right">
                        <div className="innerInfo">

                          <div className="infoRow">
                            <div className="lRow">
                              <span>{item.title}</span>
                            </div>
                            <div className="rRow">
                              <span>{item.money}</span>
                              <span>{item.people}</span>
                            </div>
                          </div>
                          <div className="infoRow">
                            <div className="lRow">
                              <i className="markMap">
                                <img style={marginTopCss} src={item.markMap} alt=""/>
                              </i>
                              <span>{item.address}</span>
                            </div>

                            <div className="rRow">
                              <span>{item.days}</span>
                              <span>{item.group}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="innerContent">
                    <div className="desc">
                      <p style={{height: isMath(recReSizeReducer, 68)}}>{desc}</p>
                    </div>
                    <div className="innerBtnPlus">
                      <svg width="29" height="18" viewBox="0 0 29 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.9387 16.5612L27.5 8.99997L19.9387 1.43869" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M26.6035 9.00009L1.50007 9.00009" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>

                    </div>
                  </div>
                  
                </li>);
          })}
        </ul>
      </div>
    </>);
  };

  const handleClickShow = (type, index) => {
    dispatch(basicDrawerEvent({
      visible: TYPES.DRAWERSHOW,
      options: {
        type,
        doTour: TYPES.TRAVELMALL,
        index
      },
    }));
  }



  return (<div className={normal}>
    {isDesktopMobile()}
  </div>);
});
export default Index;
